export enum DateFormatType {
    DATE = 'date',
    DATE_TIME = 'dateTime',
    TIME = 'time',
}
